<template>
  <v-dialog
    lazy
    scrollable
    :value="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="$store.state.common.largeDialogWidth"
    @input="((val) => $emit('update:show', val))"
  >
    <v-card>
      <v-card-title class="headline">
        <v-layout
          justify-center
          align-center
        >
          <v-icon
            large
            color="error"
            class="mr-2"
          >
            wifi_off
          </v-icon>
          {{ $t('decodersSomeOffline') }}
        </v-layout>
        <v-btn
          class="ml-auto mr-0 my-0"
          flat
          icon
          :disabled="loading"
          :title="$t('abort')"
          @click="reject()"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0">
        <p>
          {{ $t('decodersSomeSelectedOffline') }}:
          <ul style="list-style: none">
            <li
              v-for="decoder in orderedOfflineDecoders"
              :key="decoder.id"
              class="mt-1"
            >
              <icon-tv-decoder
                v-if="decoder.ctype === 'tv'"
                :tvdecoder="decoder"
                class="mr-2"
                style="display: inline-block; position: relative; bottom: -2px;"
              />
              <v-icon
                v-if="decoder.ctype === 'radio'"
                class="mr-2"
              >
                radio
              </v-icon>
              <router-link
                :to="`/player/${decoder.ctype}/${decoder.id}`"
              >
                {{ decoder.store.city }} - {{ decoder.description }}
              </router-link>
            </li>
          </ul>
        </p>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-layout column>
          <p>
            {{ $t('offlineDecodersContentActivationHint') }}.
            {{ $t('offlineDecodersTroubleshootingHint' ) }}:
            <a
              :href="troubleshootingUrl"
              target="_blank"
            >
              Troubleshooting
            </a>
            <v-checkbox
              v-model="suppressWarningForBrowserSession"
              color="msr"
              hide-details
              :label="$t('suppressWarningForBrowserSession')"
            />
          </p>
          <v-layout justify-center>
            <btn-ok
              round
              :label="$t('yesContinueAnyway')"
              :loading="loading"
              data-cy="continue-anyway-btn"
              @click="confirm()"
            />
          </v-layout>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import orderBy from 'lodash.orderby';

import suppressWarnings from '@/mixins/suppressWarnings.js';
import IconTvDecoder from '@/components/IconTvDecoder';

import BtnOk from '@/components/ButtonOk';

export default {
	components: {
		BtnOk,
		IconTvDecoder,
	},
	mixins: [
		suppressWarnings,
	],
	props: {
		'show': {
			type: Boolean,
			required: true,
		},
		'loading': {
			type: Boolean,
			default: false,
		},
		'offlineDecoders': {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			suppressWarningForBrowserSession: false,
			suppressed: false,
		};
	},
	computed: {
		orderedOfflineDecoders() {
			return orderBy(this.offlineDecoders, ['store.city', 'description']);
		},
		troubleshootingUrl() {
			return this.$store.state.common.troubleshootingUrl;
		},
	},
	methods: {
		handleSuppressionChoice() {
			if (this.suppressWarningForBrowserSession) {
				this.suppressOfflineDecoderSelectedWarning();
			}
		},
		reject() {
			this.$emit('rejected');
			this.$emit('update:show', false);
		},
		confirm() {
			this.handleSuppressionChoice();

			this.$emit('confirmed');
			this.$emit('update:show', false);
		},
	},
}

</script>



// WEBPACK FOOTER //
// src/components/OfflineDecoderSelectedDialog.vue